class SearchLogger {
    constructor(url, device) {
        this.url = url;
        this.device = device;
    }
    log(data) {
        return fetch(this.url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ ...data, device: this.device, source: 'web' }),
        });
    }
}

export { SearchLogger };
//# sourceMappingURL=searchLogger.js.map
